import { useQuery } from '@tanstack/react-query';
import { Wallet } from "@/types/Wallet";
import { WalletService } from "@/services/WalletService";
import { ApiListResponse, ListRequestGlobalProps } from "@/types/Common";
import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/utils/defaults';

const useGetWallets = (params: ListRequestGlobalProps) => {
  return useQuery<ApiListResponse<Wallet>>({
    queryKey: ['wallets', params],
    queryFn: () => WalletService.fetchWallet(params),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
  });
};
export default useGetWallets;
